import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const NAMES = ['Valeria', 'Catalina', 'Mariana', 'Sofía', 'Daniela', 'Andrea', 'Isabella', 'Natalia', 'Gabriela', 'Luciana', 'Carolina', 'Alejandra', 'Fernanda', 'Camila', 'Paula', 'Adriana', 'Juliana', 'Mónica', 'Lorena', 'Patricia', 'Elena', 'Rosa', 'Carmen', 'Beatriz', 'Diana', 'Gloria', 'Sandra', 'Claudia', 'Verónica', 'Jimena'];
const CITIES = ['Bogotá', 'Medellín', 'Cali', 'Cartagena', 'Barranquilla', 'Bucaramanga', 'Pereira', 'Manizales', 'Santa Marta', 'Ibagué', 'Monterrey', 'Ciudad de México', 'Guadalajara', 'Lima', 'Santiago', 'Buenos Aires', 'Miami', 'Madrid', 'Barcelona'];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  const [history, setHistory] = useState<string[]>([]);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;
    const showToast = () => {
      let randomName;
      do {
        randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      } while (history.includes(randomName) && history.length < NAMES.length);
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setHistory(prev => {
        const newHistory = [...prev, randomName];
        if (newHistory.length > 10) newHistory.shift();
        return newHistory;
      });
      setTimeout(() => {
        setIsVisible(false);
        scheduleNext();
      }, 4000);
    };
    const scheduleNext = () => {
      const nextInterval = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showToast, nextInterval);
    };
    const initialTimer = setTimeout(showToast, 3000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-227">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-24 sm:bottom-20 md:bottom-6 left-1/2 md:left-6 -translate-x-1/2 md:translate-x-0 z-50 bg-white rounded-xl shadow-xl border border-sage/30 p-3 sm:p-4 w-[92%] max-w-[340px] sm:max-w-sm flex items-start gap-3" data-id="element-228">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-teal/10 flex items-center justify-center shrink-0" data-id="element-229">
            <span className="font-heading font-bold text-teal text-base sm:text-lg" data-id="element-230">
              {currentData.name.charAt(0)}
            </span>
          </div>
          <div className="min-w-0 flex-1" data-id="element-231">
            <p className="text-xs sm:text-sm text-neutral-gray leading-snug mb-1 break-words" data-id="element-232">
              <span className="font-bold text-teal" data-id="element-233">{currentData.name}</span>{' '}
              <span className="whitespace-nowrap" data-id="element-234">en {currentData.city}</span>{' '}
              acaba de adquirir
            </p>
            <p className="text-[11px] sm:text-xs font-semibold text-teal mb-1 break-words" data-id="element-235">
              Sistema de Reprogramación · $9,99 USD
            </p>
            <div className="flex items-center gap-2 flex-wrap" data-id="element-236">
              <div className="flex text-gold" data-id="element-237">
                {[...Array(5)].map((_, i) => <Star key={i} size={11} fill="currentColor" data-id="element-238" />)}
              </div>
              <span className="text-[10px] text-neutral-gray" data-id="element-239">
                hace un momento
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}